/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 28/12/2021
 * @Example
 */



import Api from '../../../services/api';
import { cancel, take, takeLatest, takeEvery } from "redux-saga/effects";
import { types } from "./W05F0013_actions";
import { delay } from "redux-saga";

export default function W05F0013Sagas() {
    return [
        watchGetList(),
        watchOnAdd(),
        watchOnEdit(),
        watchGetDecimals()
    ];
}

export function* getList(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0013/get-list', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getList error')
    }
}
export function* watchGetList() {
    while (true) {
        const watcher = yield takeEvery(types.W05F0013_GET_LIST, getList);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* onAdd(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0013/save', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('onAdd error')
    }
}
export function* watchOnAdd() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0013_ADD, onAdd);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* onEdit(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0013/edit', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('onEdit error')
    }
}
export function* watchOnEdit() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0013_EDIT, onEdit);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* getDecimals(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0007/get-decimal-quantity');
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('get decimals error')
    }
}

export function* watchGetDecimals() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0013_GET_DECIMALS, getDecimals);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}